<template>
  <div>
    <!-- Rename Dialog -->
    <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow" :title="$t(`core.${action}`)"
      :default-cancel="false" :width="420" @close="closeRenameDialog">
      <ul class="form-list">
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t("core.rename")}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <input class="tc-15-input-text xs" :placeholder="$t('core.file_name')" maxlength="100" v-focus
                v-model.trim="renameName" />
              <p class="form-input-help">{{$t("cos.validate.support_char_most",{num: 100})}}</p>
            </div>
          </div>
        </li>
      </ul>

      <div slot="button">
        <div class="justify-grid">
          <div class="col"></div>
          <div class="col">
            <qc-button type="default" @click="onRename" :title="$t('core.save')">{{$t('core.save')}}</qc-button>
            <qc-button type="weak" @click="closeRenameDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
          </div>
        </div>
      </div>

    </qc-dialog>

    <qc-dialog class="tc-15-rich-dialog cos rename-progress-panel" type="custom" :show="progressShow" :width="520"
      :default-cancel="false" :no-close-button="true" :close-triggers="[]">
      <div class="header">
        <img src="~@/assets/images/logo.svg">
        <span>{{$t('core.renaming_folder')}}</span>
      </div>
      <div class="tc-15-progress">
        <div class="tc-15-progress-value" aria-valuemax="100" aria-valuemin="0" :aria-valuenow="progress"
          :style="{width:progress+'%'}">
        </div>
      </div>

      <div slot="button" v-if="0">
        <div class="justify-grid">
          <div class="col"></div>
          <div class="col">
            <qc-button type="weak" :disable="disableCancel" @click="cancelRename" :title="$t('core.cancel')">
              {{$t('core.cancel')}}</qc-button>
          </div>
        </div>
      </div>
    </qc-dialog>
  </div>

</template>

<script>
import {
  tips, getInnerProps, formatTime, path,
} from '@/scripts/tools/utils';
import dialog from '@/scripts/tools/dialog';
import eventProxy from '@/scripts/tools/eventProxy';
import cos from '@/scripts/helper/cos/index';
import { renameFolder } from '@/scripts/helper/cos/cosSdkUtils';
import copyer from '@/scripts/helper/copyer';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      source: {},
      target: {},
      renameItem: {},
      oldName: '',
      renameName: '',
      action: 'rename',

      progressShow: false,
      progress: 0,
      disableCancel: false,
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  mounted() {
    eventProxy.on('show.rename', this.initData);
  },
  destroyed() {
    eventProxy.off('show.rename', this.initData);
  },
  methods: {
    initData({ source, target, action = 'rename' }) {
      this.source = source;
      copyer.copy(source);
      this.target = target;
      this.action = action;
      [this.renameItem] = source.files;
      this.renameName = this.renameItem.name;

      // 是否同目录复制
      if (
        ['copy', 'move'].includes(action)
        && source.Bucket + source.Prefix === target.Bucket + target.Prefix
      ) {
        const itemName = this.renameItem.name;
        const dateTime = formatTime(Date.now(), 'YYYYMMDD_HHmmss');
        const ext = path.extname(itemName);
        const baseName = path.basename(itemName, ext);
        this.renameName = `${baseName}_${dateTime}${ext}`;
      }

      this.oldName = this.renameItem.name;
      this.progress = 0;

      this.innerShow = true;
    },
    exsitSameName() {
      const { Bucket, Region, Prefix } = this.target;
      return new Promise(resolve => {
        // 1. 确认是否存在同名文件
        cos.headObject(
          {
            Bucket,
            Region,
            Key: Prefix + this.renameName,
          },
          err => {
            if (err) {
              if (err.statusCode === 404) {
                // 2. 不存在则直接进行重命名
                resolve(true);
              } else if (err.error === 'Forbidden' && err.statusCode === 403) {
                tips.error(this.$t('error.no_permissions_to_head_object'));
              } else {
                const code = err.error || err.code;
                tips.error(
                  window.lang.err(`error.${code}`, err.code ? err : err.code),
                );
              }
              resolve(false);
              return;
            }
            // 3. 存在则提示是否覆盖
            dialog.confirm(
              { message: window.lang.t('cos.confirm.rename_cover') },
              confirm => {
                if (confirm) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              },
            );
          },
        );
      });
    },
    onRename() {
      if (this.renameItem.isDir) {
        this.renameFolder();
      } else {
        this.renameFile();
      }
    },
    checkRename() {
      const { lang } = window;
      let allow = true;
      const { renameName } = this;
      if (!renameName) {
        tips.error(lang.t('cos.validate.empty_file_name'));
        allow = false;
      } else if (renameName.indexOf('/') > -1) {
        tips.error(this.$t('error.not_allow_rename_with_slash'));
        allow = false;
      }

      return allow;
    },
    // 文件重命名
    async renameFile() {
      const validate = this.checkRename();
      if (!validate) return;

      const oldItem = this.renameItem;
      const oldKey = oldItem.key;
      const newKey = this.target.Prefix + this.renameName;
      if (newKey === oldKey && this.action === 'rename') {
        this.closeRenameDialog();
        tips.success(this.$t(`state.success.${this.action}`));
        return;
      }

      const allowRename = await this.exsitSameName();
      if (!allowRename) return;

      this.closeRenameDialog();
      if (newKey === oldKey && this.action === 'rename') {
        tips.success(this.$t(`state.success.${this.action}`));
        return;
      }

      const fileNameMap = {};
      fileNameMap[oldKey] = this.renameName;

      const action = this.action === 'rename' ? 'move' : this.action;
      copyer[`${action}To`](
        // target
        {
          ...this.target,
          fileNameMap,
          allowSituCopy: true,
          action: this.action,
        },
        (err, data) => {
          tips.closeTips();
          if (data) {
            if (data.successList.length) {
              tips.success(this.$t(`state.success.${this.action}`));
              this.renameItem.newKey = newKey;
              this.$emit('refresh', this.renameItem);
            } else {
              tips.error(this.$t(`state.fail.${this.action}`));
            }
          } else {
            tips.error(this.$t(`state.fail.${this.action}`));
          }
        },
      );

      if (oldItem.isCollection) {
        eventProxy.emit('collectionChanged', {
          oldData: { Bucket: oldItem.Bucket, Region: oldItem.Region, Key: oldKey },
          newData: { Bucket: oldItem.Bucket, Region: oldItem.Region, Key: newKey },
        });
      }
    },
    // 重命名文件夹
    renameFolder() {
      this.closeRenameDialog();
      this.progressShow = true;

      const { Bucket, Region, prefix } = this.target;
      const oldItem = this.renameItem;
      const oldKey = oldItem.key;
      const newKey = `${prefix + this.renameName}/`;
      if (newKey === oldKey) return;

      const onProgress = data => {
        console.log('[rename folder progress]', data);
        this.progress = data.percent * 100;
      };

      if (newKey === oldKey) {
        this.progressShow = false;
        tips.success(this.$t(`state.success.${this.action}`));
        return;
      }

      renameFolder(
        {
          Bucket, Region, oldKey, newKey, onProgress,
        },
        (err, data) => {
          tips.closeTips();
          if (err) {
            const { error } = err;
            const code = (error && error.Code) || err.Code;
            const message = window.lang.err(`error['${code}']`, err);
            tips.notification({ type: 'error', message });
          } else if (data) {
            eventProxy.emit('collectionChanged', {
              oldData: { Bucket, Region, Key: oldKey },
              newData: { Bucket, Region, Key: newKey },
            });
            this.disableCancel = true;
            const msg = data.success
              ? window.lang.err(`error['${data.sucess}']`, data.sucess)
              : this.$t('state.success.rename');
            tips.success(msg);
          }
          // err,data 为 null，说明用户取消了重命名
          this.progressShow = false;
          this.$emit('refresh');
        },
      );
    },
    // 取消重命名文件夹
    cancelRename() {
      this.progressShow = false;
    },
    closeRenameDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.rename-progress-panel {
  ::v-deep .tc-15-rich-dialog {
    .tc-15-rich-dialog-hd {
      display: none;
    }
    .tc-15-rich-dialog-bd {
      padding-bottom: 20px;
    }
  }

  .header {
    display: flex;
    align-items: center;
    > span {
      font-size: 16px;
      margin-left: 15px;
    }
  }

  .tc-15-progress {
    border-radius: 0;
    height: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .tc-15-progress-value {
    height: 16px;
    border-radius: 0;
    background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent
    );
    background-size: 40px 40px;
  }
}
</style>
